import axios from "axios";
import * as actionType from "../../constant/actionType";

export const GetProvClientAndWorkerComplianceStatusCount = (apiData) => async (dispatch) => {
    /*** API Call Action ***/
    try {
        const response = await axios({
            method: "get",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
            },
            url: `${actionType.environment_url}/api/admin/provider/SpecificProviderWorkerDashboardComplianceStatus`,
            params: apiData,
        });
        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const GetAllWorkersOfProviderForComplianceCount = (apiData) => async (dispatch) => {
    try {
        const response = await axios({
            method: "get",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
            },
            url: `${actionType.environment_url}/api/admin/provider/GetAllWorkersOfProvider`,
            params: apiData,
        });
        return response.data;
    } catch (error) {
        return error.message;
    }
};
